export default __webpack_public_path__ + "static/media/cloud_infrastructure.5fd77f6b.svg";